<template>
  <div class="survey-action">
    <div class="buttons-container">
      <router-link v-if="showBackButton" to="/" class="btn-secondary">
        {{ t({ fr: "Retour à l'accueil", en: 'Back to home' }) }}
      </router-link>
      <router-link to="/survey" class="start-survey-btn">
        {{ t({ fr: 'Débuter la soumission', en: 'Start submission' }) }}
      </router-link>
    </div>
  </div>
</template>

<script>
import { t } from '../i18n/index.js'

export default {
  name: 'StartSurveyButton',
  props: {
    showBackButton: {
      type: Boolean,
      default: false
    }
  },
  methods: { t }
}
</script>

<style scoped>
.survey-action {
  text-align: center;
  margin-top: 40px;
  padding-top: 30px;
  border-top: 2px solid var(--aecom-lime-green);
}

.buttons-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.btn-secondary {
  padding: 12px 30px;
  border-radius: 25px;
  text-decoration: none;
  font-weight: 600;
  text-align: center;
  transition: all 0.3s ease;
  max-width: 200px;
  background: transparent;
  color: var(--aecom-midnight-teal);
  border: 2px solid var(--aecom-midnight-teal);
}

.btn-secondary:hover {
  background: var(--aecom-midnight-teal);
  color: white;
  transform: translateY(-2px);
}

.start-survey-btn {
  display: inline-block;
  background: var(--aecom-earth-green);
  color: var(--aecom-white);
  padding: 15px 40px;
  text-decoration: none;
  border-radius: 25px;
  font-size: 1.1rem;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 135, 104, 0.3);
  text-transform: uppercase;
  letter-spacing: 1px;
}

.start-survey-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 135, 104, 0.4);
  background: var(--aecom-midnight-teal);
}

@media (max-width: 768px) {
  .buttons-container {
    flex-direction: column;
    gap: 15px;
  }
  .btn-secondary {
    max-width: 100%;
    width: 100%;
  }
  .start-survey-btn {
    padding: 12px 30px;
    font-size: 1rem;
    width: 100%;
    max-width: 300px;
  }
}
</style>
